import { styled } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  TABLE_FONT_SIZE,
  TABLE_ROW_HEIGHT,
  TEXT_FONT_FAMILY,
} from "./Variables";

export const StyledDatagrid = styled(DataGridPro)(({ theme }) => ({
  "& .MuiDataGrid-columnHeaders": {
    minHeight: "35px !important",
    maxHeight: "35px !important",
    lineHeight: "35px !important",
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: 16,
    color: "white",
    fontWeight: 700,
  },

  "& .MuiDataGrid-columnHeader": {
    minHeight: "35px !important",
    maxHeight: "35px !important",
    lineHeight: "35px !important",
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: 16,
    color: "white",
    fontWeight: 700,
    backgroundColor: "var(--level-7)",
    textAlign: "center !important",
    borderRight: "1px solid white",
    "& .MuiSvgIcon-root": {
      color: "white !important",
    },
  },

  "& .MuiDataGrid-columnHeader--pinnedLeft": {
    backgroundColor: "var(--level-9) !important",
  },
  "& .MuiDataGrid-cell--pinnedLeft": {
    backgroundColor: "var(--level-2) !important",
    overFlow: "hidden",
    zIndex: "999 !important",
  },
  "& .MuiDataGrid-cell--pinnedRight": {
    backgroundColor: "var(--level-2) !important",
    overFlow: "hidden",
    zIndex: "999 !important",
  },
  "& .MuiDataGrid-columnHeader--pinnedRight": {
    backgroundColor: "var(--level-9) !important",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid var(--border-color)",
    borderRight: "1px solid var(--border-color)",
    backgroundColor: "var(--level-1)",
    color: "var(--text-color)",
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: TABLE_FONT_SIZE,
    padding: "0px 5px  !important",
    "& .MuiSvgIcon-root": {
      color: "var(--level-6) !important",
    },
  },
  "& .MuiDataGrid-row": {
    // "&:nth-of-type(odd)": {
    //   backgroundColor: "#f9f9f9",
    // },
    "&:hover  .MuiDataGrid-cell": {
      backgroundColor: "var(--level-2) !important",
      color: "var(--level-5)",
    },
    "& .number-cell": {
      fontFamily: "Spline Sans Mono, monospace !important",
    },
    "& .Mui-selected": {
      backgroundColor: "var(--level-4)",
      color: "var(--level-5)",
    },
    "&:hover .td-link": {
      textDecoration: "underline",
      cursor: "pointer",
    },
    "&:hover .total-count ": {
      backgroundColor: "#4ade80 !important",
    },
    "&:hover .balance-count ": {
      backgroundColor: "#ef4444 !important",
    },
  },

  "& .MuiDataGrid-pinnedRows": {
    position: "-webkit-sticky ",
    zIndex: 4,
    backgroundColor: " #fff",
    boxShadow: "0px -3px 4px -2px rgba(0, 0, 0, 0.21)",
    bottom: 0,
  },
  "& .MuiDataGrid-footerContainer": {
    minHeight: TABLE_ROW_HEIGHT,
  },
  "& .MuiDataGrid-pagination": {
    backgroundColor: "var(--bg-color)", // Change pagination background color
    fontWeight: 700,
  },
  "& .MuiDataGrid-rowCount": {
    color: "var(--text-color)",
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: TABLE_FONT_SIZE,
  },
  "& .MuiList-root": {
    paddingTop: "5px !important",
  },
  "& .MuiButtonBase-root": {
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: TABLE_FONT_SIZE,
    "&:hover": {
      backgroundColor: "var(--level-2)",
      color: "var(--level-5)",
    },
  },
  "& .MuiDataGrid-selectedRowCount": {
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: TABLE_FONT_SIZE,
  },
  "& button": {
    lineHeight: 0,
  },
}));
export const useDataGridStyles = () => {
  return {
    headerStyles: {
      "& .MuiDataGrid-columnHeader": {
        whiteSpace: "normal",
        lineHeight: "3",
        fontSize: "12px",
        fontWeight: 700,
      },
      "& .MuiDataGrid-columnHeaderTitle": {
        overflow: "visible",
        textOverflow: "clip",
        whiteSpace: "normal",
        wordWrap: "break-word",
      },
    },
  };
};
